export default __webpack_public_path__ + "static/1-868760e2c469490e4197994f3c58ee32.jpg";